module.exports = __webpack_public_path__ + "static/media/facebook-square.4b6764f2.svg";